import { Dispatch, SetStateAction } from "react";
import {
  Modal,
  Button,
  TextField,
  Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddIntroScreen({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Intro Screen</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            {/* Image Upload */}
            <div className="control_group w_50">
              <label>
                Upload Image <Button className="sm btn btn_primary">Enhance with AI</Button>
              </label>

              <label className="upload_image v2">
                <Input
                  sx={{ display: "none" }}
                  type="file"
                  inputProps={{ accept: "image/png,image/jpeg" }}
                />
                <span className="upload_image_holder no_radius">
                  <figure className="add_img">
                    <img
                      src="/static/images/placeholder.png"
                      alt="placeholder"
                    />
                    <span className="upload_img_icon">
                      <img
                        src="/static/images/edit2_icon.svg"
                        alt="edit"
                      />
                    </span>
                  </figure>
                </span>
              </label>
            </div>

            {/* Title */}
            <div className="control_group">
              <label htmlFor="intro-title">Title</label>
              <TextField
                placeholder="Enter Title"
                fullWidth
                hiddenLabel
                inputProps={{ id: "intro-title" }}
              />
            </div>

            {/* Description */}
            <div className="control_group ai_rec_btn">
              <label htmlFor="intro-description">Description</label>
              <TextField
                placeholder="Enter Description"
                fullWidth
                hiddenLabel
                multiline
                rows={4}
                inputProps={{ id: "intro-description" }}
              />
              <Button className="btn btn_primary sm">
                <img src="/static/images/ai_icon.svg" alt="ai_icon"/>
                Enhance with AI
              </Button>
            </div>

            {/* Footer Buttons */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button className="btn btn_primary">
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}